import React, { useEffect } from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import { Tabs, Tablist } from "../../components/ui/Tabs/Tabs";
import ManualShipping from "./Section/ManualShipping";
import PushNotificationList from "./Section/PushNotificationList";

const tabs = [
  {
    title: "수동 발송",
    id: 1,
  },
  {
    title: "푸시알림 발송 리스트",
    id: 2,
  },
];

const PushNotification = () => {
  const storedSelectedTab = localStorage.getItem("selectedTab") ?? 1;
  const hasSelectedTab =
    storedSelectedTab !== undefined || storedSelectedTab !== "";
  const [currentTab, setCurrentTab] = React.useState(
    hasSelectedTab ? parseInt(storedSelectedTab) : 1
  );
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  useEffect(() => {
    if (hasSelectedTab) {
      setCurrentTab(parseInt(storedSelectedTab));
      localStorage.removeItem("selectedTab");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <TitlePage title="푸시알림 발송" />
      <div>
        <Tabs
          onChangeTab={onChangeTab}
          currentTab={currentTab}
          tabs={tabs}
          tabWidth="px-4"
          titleTabPosition="justify-center"
        >
          <Tablist currentTab={currentTab} index={1}>
            <ManualShipping />
          </Tablist>
          <Tablist currentTab={currentTab} index={2}>
            <PushNotificationList />
          </Tablist>
        </Tabs>
      </div>
    </div>
  );
};

export default PushNotification;
